<template>
    <div class="drawerLayer" v-show="visible">
        <div class="mask" @click="ok()"></div>
        <div class="bottomDrawer white_bg" style="height: 530px;">
            <div class="h100p">
                <div class="body h100p relative" style="margin-top: 10px; padding-bottom: 34px;">
                    <div class="generalPagePaddingH" style="padding-top: 16px;">
                        <div class="color333 bold" style="margin-bottom: 24px">薪资待遇</div>
                        <div class="clearfix">
                            <span class="tag" :class="{active : selectedSalaryOption == salaryItem}"
                              v-for="salaryItem in salaryList" :key="salaryItem.id"
                                  @click="selectedSalaryOption=salaryItem">
                                <template v-if="salaryItem.salaryMin == 0">面议</template>
                                <template v-else-if="salaryItem.salaryMax == 0">{{salaryItem.salaryMin * 1000}}元以上/月</template>
                                <template v-else>{{salaryItem.salaryMin * 1000}}～{{salaryItem.salaryMax * 1000}}元/月</template>
                            </span>
                        </div>
                    </div>
                    <div style="height: 82px;">
                        <div class="operationArea w100p h100p" style="position:absolute; height: 48px; bottom: 34px;
                            box-shadow: 0px -8px 8px rgba(77, 77, 77, 0.05);">
                            <div class="generalPagePaddingH paddingV8">
                                <div class="flexLayout">
                                    <div style="width: 122px">
                                        <button class="button block clearButton" @click="clear()">清除</button>
                                    </div>
                                    <div class="flexItem marginL8">
                                        <button class="button block okButton" @click="ok()">确定</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import drawerPart from '../../part/drawerPart';


const config = {
    apiConfig : {
        list : {
            url : "",
            dataPath : 'data.records',
            totalPagePath : 'data.pages',
            dataColumnMapping : {
                // userName : 'name''
            }
        },
        get : {
            url : '',
            dataColumnMapping : {
                // userName : 'name'
            }
        }
    }
};

export default {
    name: "drawerTemplate",
    extends : drawerPart,
    data() {
        return {
            apiConfig : config.apiConfig,
            salaryList : [{
                salaryMin : 0,
                salaryMax : 0,
            },{
                salaryMin : 2,
                salaryMax : 3,
            },{
                salaryMin : 3,
                salaryMax : 4,
            },{
                salaryMin : 4,
                salaryMax : 5,
            },{
                salaryMin : 5,
                salaryMax : 8,
            },{
                salaryMin : 12,
                salaryMax : 0,
            },],
            selectedSalaryOption : null
        }
    },
    methods : {
        clear() {
            this.selectedSalaryOption = null;
        },
        ok() {
            this.$emit('change', this.selectedSalaryOption);
            this.close();
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    .closeIcon {
        width: 14px;
        height: 14px;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACFklEQVRoge2ZQU/bMBhALWCdhPgZvfnk7305k/MkdhgwumqI/vkxpE2CaTsgtaG7xCjqbEiKnWRSntRDqzp+L0nbNDZmYmIiCHBsrT0Z2sNaewIcdxqkqh+AP8CjiHzO5PYqIvIJeAR+q2rZdtwhcAts68daVc8zegZR1Qtg3fC4NcYcvDoQeAc8NAb6iIv82s8OlzvyW+DeGHPYdgNLEakCEdmPRGDPb4EnEbnqtCERWfUdISJXEfnVvhsMRgCXadWf5TfJ5BsbDkVsnHNf0qhnlG9MkC0iu3xjouQRIfl6jpuU7s0Jk0XE5FX1Ood7c+I3Rwwm3xDYO8I5txhU3rNPBLAEqsHlPV0iRifvaRMxWnnPSxEheWA88p5YROC1ClgO7RtERL4GflX/D3lPfdr8E1EfiXHLG2OMql4HTpvkF4BZeEF+/BEh+fr57uk0vojInq+AZeQzMZ6IiPzGObfw74lFJL/m70pMPvQHPBQhItVgEV3kPaOJAG66ynsGjxCRFfC0j7xnsIgU8p7eI1LKe3qLiMiv3yLvyR4Rk095szdbRB/ynuQRfcp7kkWo6qJveQ+BtYE6ot1KkbV2BvzalSfDHekYkTWCe2vtrM34A+B786uyz9UZj6qe70R8M22WmIwxpiiKU+AO+CEiZ3lV4zjnPgI/gbuiKE47DS7L8mg+n7/P5NYaa+2sLMujoT0mJsbKX2RBsPwpegpvAAAAAElFTkSuQmCC');
    }
}
.tag {
    display: inline-block;
    padding: 0 6px;
    height: 26px;
    line-height: 26px;
    background: #F2F3F8;
    border-radius: 4px;
    font-size: 14px;
    color: #5B616C;
    margin-right: 16px;
    margin-bottom: 16px;

    &.active {
        background: #FFC439;
        color: white;
    }
}
.operationArea {
    .button {
        height: 36px;
        line-height: 36px;
        border-radius: 18px;
        font-size: 14px;
    }
    .clearButton {
        background: #F2F3F8;
        color: #333;
    }
    .okButton {
        background: #FFA724;
        color: white;
    }

}
</style>
